import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CalendarioRangoService {

  rangoSeleccionado:string = '';

  constructor() { }
}
